import { useNavigate } from "react-router-dom";
import { useFlightContext } from "./useFlightContext";
import { useTranslation } from "react-i18next";
import useApiClient from "hooks/useApiClient";
import { createAirValidatePayload } from "helpers/flightHelper";
import { toast } from "react-toastify";
import { useLoadingContext } from "states/loadingContext";
import useMimir from "hooks/useMimir";

const useAirValidate = () => {
    const { api, urls } = useApiClient();
    const { setAirValidateResults, flightSearchParams } = useFlightContext();
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const { hideLoading, showLoading } = useLoadingContext();
    const { mimir } = useMimir();

    const buildMimirPayload = (payload, result) => {
        return {
            type: "FLIGHT",
            event: "AIRVALIDATE",
            param1: JSON.stringify(payload || {}),
            param2: JSON.stringify(result || {}),
        };
    };

    const handleBooking = (flight) => {
        if (!flight) return;
        const payload = createAirValidatePayload(flight);
        if (!payload) return;
        payload["language"] = i18n.language;
        payload["openReturn"] = flightSearchParams?.openReturn ? "true" : "false";
        showLoading();
        let result;
        api.post(
            urls.flight.airValidate + `?language=${i18n.language}`,
            JSON.stringify(payload),
        )
            .then((res) => {
                if (res.status === 200) {
                    if (res.data?.originalResponse?.status === "OK") {
                        if (res.data?.result?.isBookable) {
                            setAirValidateResults({
                                flight,
                                canBeBookedOnhold: true, //TODO
                                allowMinorSinglePassenger:
                                    res.data?.result
                                        ?.allowMinorSinglePassenger || false,
                                paxNameCharacterLimit:
                                    res.data?.result?.paxNameCharacterLimit ||
                                    15,
                                paxNameCharacterLimitINF:
                                    res.data?.result
                                        ?.paxNameCharacterLimitINF || 15,
                                extraServices: res.data?.result?.extraServices,
                                customerAddressMandatory:
                                    res.data?.result
                                        ?.customerAddressMandatory || false,
                            });
                            navigate("/flight-booking");
                        } else {
                            console.log("not bookable");
                            toast.error(t("flightNotAvailable"));
                        }
                        result = {
                            ...res?.data?.result,
                            ...res?.data?.providers,
                        };
                    } else {
                        toast.error(t("flightNotAvailable"));
                    }
                }
                if(!result)
                    result = { status: "Not ok" }
            })
            .catch((err) => {
                if (err?.code === "ERR_NETWORK") {
                    toast.error("Network error, please try again later.");
                    return;
                }
                console.log("err", err);
                toast.error("Something went wrong, please try again later");
            })
            .finally(() => {
                hideLoading();
                mimir.log(buildMimirPayload(payload,result))
            });
    };
    return { handleBooking };
};

export default useAirValidate;
